/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import { Box, Text } from '@chakra-ui/react'
import { useParams, Redirect } from 'react-router-dom'
import { SharedContextProvider } from '../../context/shared.context'
import { SmartFormContextProvider } from '../../context/smart-form.context'
import SmartFormPanel from '../../containers/form-panel/smart-form-panel'
import { setLocalAuthDetails } from '../../utils/common.util'
import { IS_EXTERNAL } from '../../utils/constant'
import { useEmailContext } from '../../routes/email/email.route'
import { useLoadFormFieldList } from '../../hooks/form.hooks'
import { useLoadActivityDetails } from '../../hooks/activity.hooks'
import FormEditPanel from './email-form-edit-panel'
import { useLoadS3Creds } from '../../hooks/shared.hooks'
import { useLanguageContext } from '../../context/locale.context'
import { useGetTranslations } from '../../hooks/dashboard.hooks'
import { localizationConst } from '../../utils/action.constant'
import { useAuthContext } from '../../context/auth.context'

function EmailFormPreview(props) {
  const context = useEmailContext()
  const urlParams = useParams()
  const [urlData, setUrlData] = useState(null)
  const { mutate, isLoading } = useLoadFormFieldList()
  const { mutate: activityDetails } = useLoadActivityDetails()
  const { mutate: mutateS3Creds } = useLoadS3Creds()
  const { mutate: loadLanguageTexts } = useGetTranslations()

  const {
    state: { authData },
  } = useAuthContext()

  const {
    state: { locale, selectedLanguage },
    dispatch: languageDispatch,
  } = useLanguageContext()

  useEffect(() => {
    try {
      let url = atob(urlParams?.params)
      let parsed = JSON.parse(url)
      if (parsed) {
        if (parsed.url_form_data) {
          setUrlData({
            ...JSON.parse(parsed.url_form_data),
            ...{ form_name: context.formName, is_external: 'true' },
          })
        } else {
          setUrlData({
            ...parsed,
            ...{ form_name: context.formName, is_external: 'true' },
          })
        }
        context.setOrgId(parsed.organization_id)
        mutateS3Creds()
      }
    } catch (error) {
      console.log(error)
    }
    return () => {}
  }, [urlParams, context.formName])

  useEffect(() => {
    Object.keys(locale).length === 0 &&
      setSelectedLanguage({ label: 'English', value: 1 })
  }, [locale, authData])

  const setSelectedLanguage = selectedLanguage => {
    loadLanguageTexts(
      {
        asset_id: authData?.asset_id,
        asset_token_auth: authData?.asset_token_auth,
        language_id: selectedLanguage.value,
        limit_value: 600,
        start_from: 0,
      },
      {
        onSuccess: data => {
          if (!!data)
            languageDispatch({
              type: localizationConst.SET_SELECTED_LANGUAGE,
              selectedLanguage,
              data,
            })
        },
        onError: err => {},
      }
    )
  }

  useEffect(() => {
    if (urlData && authData && !!urlData.form_id) {
      mutate(
        {
          organization_id: authData.organization_id,
          account_id: authData.account_id,
          workforce_id: authData.workforce_id,
          form_id: urlData.form_id,
        },
        {
          onSuccess: async data => {
            if (data && data[0]) {
              if (data[0].form_name) {
                context.setFormName(data[0].form_name)
              }
            }
          },
        }
      )
      activityDetails(
        { activity_id: urlData.activity_id },
        {
          onSuccess: async data => {
            //console.log(data, 'ddd');
          },
        }
      )
    }
  }, [urlData, authData])

  return (
    <Box bg="white" w={'50vw'} borderRadius="md" p={2}>
      <SharedContextProvider>
        <SmartFormContextProvider>
          {urlData && (
            <FormEditPanel
              isOpen={true}
              onClose={() => {}}
              activity={{ activity_id: urlData.activity_id,  activity_type_id: urlData.activity_type_id }}
              formData={urlData}
              refillForm={() => {}}
              isFormEnable={true}
              height="calc(100vh - 130px)"
            />
          )}
        </SmartFormContextProvider>
      </SharedContextProvider>
    </Box>
  )
}

export default EmailFormPreview
